/** See `src/i18n/locales/en/manageSupport.ts`. */
export const manageSupport = {
  page: {
    title: 'Suporte',
    lead: 'Todos os tickets de suporte da plataforma, filtráveis por estado e prioridade.',
    filterStatus: 'Estado',
    filterPriority: 'Prioridade',
    allStatuses: 'Todos os estados',
    allPriorities: 'Todas as prioridades',
    empty: 'Nenhum ticket corresponde a estes filtros.',
    rowsLabel: 'os tickets',
    subject: 'Assunto',
    company: 'Empresa',
    status: 'Estado',
    priority: 'Prioridade',
    createdAt: 'Aberto',
  },
  status: {
    open: 'Aberto',
    in_progress: 'Em curso',
    resolved: 'Resolvido',
    closed: 'Fechado',
  },
  priority: {
    low: 'Baixa',
    normal: 'Normal',
    high: 'Alta',
    urgent: 'Urgente',
  },
  detail: {
    thisTicket: 'este ticket',
    requesterTitle: 'Requerente',
    requesterLabel: 'o requerente',
    controlsTitle: 'Estado e prioridade',
    save: 'Guardar',
    threadTitle: 'Conversa',
    threadEmpty: 'Ainda sem mensagens.',
    replyLabel: 'Resposta',
    reply: 'Enviar resposta',
  },
} as const;
